import { defineMessages } from 'react-intl';

export default defineMessages({
    ChoosePlaymentPlan: {
        id: 'ml.common.component.MLPaymentScheduleComponent.Choose a payment plan',
        defaultMessage: 'Choose a payment plan'
    },
    FourPay: {
        id: 'ml.common.component.MLPaymentScheduleComponent.Four pay',
        defaultMessage: 'Four pay'
    },
    HowWillThisWork: {
        id: 'ml.common.component.MLPaymentScheduleComponent.How will this work?',
        defaultMessage: 'How will this work?'
    },
    MonthlyPayment: {
        id: 'ml.common.component.MLPaymentScheduleComponent.Monthly payment',
        defaultMessage: 'Monthly payment'
    },
    PayInFull: {
        id: 'ml.common.component.MLPaymentScheduleComponent.Pay in full',
        defaultMessage: 'Pay in full'
    },
    PaymentAmountDueTodayIs: {
        id: 'ml.common.component.MLPaymentScheduleComponent.Payment amount due today is',
        defaultMessage: 'Payment amount due today is'
    },
    SaveX: {
        id: 'ml.common.component.MLPaymentScheduleComponent.Save x',
        defaultMessage: 'Save {amount}'
    },
    MonthlyDescription: {
        id: 'ml.common.component.MLPaymentScheduleComponent.MonthlyDescription',
        defaultMessage: 'The Monthly option means your payment will occur each month on the same calendar date.  The Twice a Month option means you select the first deduction date and the second deduction date will occur 15 calendar days later.  Please note that if you select your first deduction to begin in the last half of the month, the second deduction will occur in the first half of the following month. <a>Read more</a>'
    },
    IncludesTaxesAndFees: {
        id: 'ml.common.component.MLPaymentScheduleComponent.This includes taxes and fees and may not equal future installments.',
        defaultMessage: 'This includes taxes and fees and may not equal future installments.'
    },
    TwicePerMonth: {
        id: 'ml.common.component.MLPaymentScheduleComponent.Twice per month',
        defaultMessage: 'Twice per month'
    },
    TwoPay: {
        id: 'ml.common.component.MLPaymentScheduleComponent.Two pay',
        defaultMessage: 'Two pay'
    },
    WhichDayOfMonth: {
        id: 'ml.common.component.MLPaymentScheduleComponent.Which day of the month do you want the payment to occur?',
        defaultMessage: 'Which day of the month do you want the payment to occur?'
    },
    WouldCustomerLike: {
        id: 'ml.common.component.MLPaymentScheduleComponent.Would the customer like an email reminder three (3) days prior to the payment being processed?',
        defaultMessage: 'Would the customer like an email reminder three (3) days prior to the payment being processed?'
    },
    WouldYouLike: {
        id: 'ml.common.component.MLPaymentScheduleComponent..Would you like to receive an email reminder three (3) days prior to payments being processed?',
        defaultMessage: 'Would you like to receive an email reminder three (3) days prior to payments being processed?'
    },
    BiMonthly: {
        id: 'ml.common.component.MLPaymentScheduleComponent.bi-monthly',
        defaultMessage: 'bi-monthly'
    },
    HalfYear: {
        id: 'ml.common.component.MLPaymentScheduleComponent.half year',
        defaultMessage: 'half year'
    },
    Monthly: {
        id: 'ml.common.component.MLPaymentScheduleComponent.monthly',
        defaultMessage: 'monthly'
    },
    ThreeMonths: {
        id: 'ml.common.component.MLPaymentScheduleComponent.three months',
        defaultMessage: 'three months'
    },
    Year: {
        id: 'ml.common.component.MLPaymentScheduleComponent.year',
        defaultMessage: 'year'
    },
    FullPayMessageContent: {
        id: 'ml.common.component.MLPaymentScheduleComponent.messageContent',
        defaultMessage: '{paymentMessage} ({premium}/{scheduleMessage}) {saveXMessage}'
    },
    PayPlanSecondaryLabel: {
        id: 'ml.common.component.MLPaymentScheduleComponent.secondary label',
        defaultMessage: '{paymentDueMessage} {paymentDueAmount}. {taxMessage}'
    },
    DayOfMonthTooltipContent: {
        id: 'ml.common.component.MLPaymentScheduleComponent.DayOfMonth Tooltip Content',
        defaultMessage: 'The Monthly option means your payment will occur each month on the same calendar date.  The Twice a Month option means you select the first deduction date and the second deduction date will occur 15 calendar days later.  Please note that if you select your first deduction to begin in the last half of the month, the second deduction will occur in the first half of the following month.'
    },
    DayOfMonthTooltipLink: {
        id: 'ml.common.component.MLPaymentScheduleComponent.Read more',
        defaultMessage: 'Read more'
    },
    PreferredPaymentPlanLabel: {
        id: "ml.common.component.MLPaymentScheduleComponent.PreferredPaymentPlan",
        defaultMessage: "Preferred Payment Plan"
    },
    PreferredPaymentPlanSecondaryLabel: {
        id: "ml.common.component.MLPaymentScheduleComponent.Does the customer agree to pay via a preferred payment method other than a credit card?",
        defaultMessage: "Does the customer agree to pay via a preferred payment method other than a credit card?"
    },
    TwoPayAnnualAutopay: {
        id: 'ml.common.component.MLPaymentScheduleComponent.Two pay Annual Autopay',
        defaultMessage: 'Two Pay Annual Autopay'
    }
});
